import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CustomPlayerVolumeSlider.module.scss';

type Props = {
  volume: number;
  onChange: (volume: number) => void;
  visible: boolean;
};

const CustomPlayerVolumeSlider: React.FC<Props> = ({ volume, onChange, visible }) => {
  const { t } = useTranslation('player');

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.panelAnchor} data-player-popup>
      <div className={styles.panel}>
        <div className={styles.trackWrap}>
          <div className={styles.track}>
            <div className={styles.fill} style={{ height: `${volume}%` }} />
          </div>
          <div className={styles.thumb} style={{ bottom: `${volume}%` }} />
          <input
            type="range"
            min={0}
            max={100}
            value={volume}
            className={styles.slider}
            onChange={(event) => onChange(Number(event.target.value))}
            aria-label={t('volume')}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomPlayerVolumeSlider;
